import { MetricBase, defaultMetricBase } from './metrics';
import { MonthlyClaimActivity } from './monthlyClaimActivity';

export interface AdjusterInvoice {
    invoiceId: number; 
    insuranceCompany: string; 
    claimId: number; 
    claimNumber: string; 
    insured: string; 
    invoiceNumber: string; 
    invoiceDt: Date; 
    grossLoss: number; 
    totalFees: number; 
    totalPaid: number; 
    totalOutstanding: number; 
    adjusterTotal: number; 
    adjusterBalance: number; 
    advancedPayrolled: number; 
    totalPayrolled: number;
    hasPdf: boolean; 
}

export interface AdjusterPayrollByMonth {
    order: number; 
    month: string; 
    amount: number; 
    advancedAmount: number; 
}

export interface ClaimsByCarrier {
    carrier: string; 
    claims: number; 
}

export interface AdjusterDashboard {    
    adjusterInvoices: AdjusterInvoice[]; 
    awaitingCarrierPaymentAmt: MetricBase<number>
    advancesBalanceAmt: MetricBase<number>
    lastPayrollAmt: MetricBase<number>
    ytdAdvancesAmt: MetricBase<number>
    awaitingPayrollAmt: MetricBase<number>
    claimsByMonth: MonthlyClaimActivity[]; 
    closedYtd: MetricBase<number>;     
    lifetimeClosed: MetricBase<number>;
    openClaimsByCarrier: ClaimsByCarrier[]; 
    payrollByMonth: AdjusterPayrollByMonth[]; 
    ytdPayrollAmt: MetricBase<number>; 
}

export const defaultAdjusterDashboard: AdjusterDashboard = {    
    adjusterInvoices: [] as AdjusterInvoice[],
    awaitingCarrierPaymentAmt: defaultMetricBase,
    advancesBalanceAmt: defaultMetricBase,
    lastPayrollAmt: defaultMetricBase,
    ytdAdvancesAmt: defaultMetricBase,
    awaitingPayrollAmt: defaultMetricBase,
    claimsByMonth: [] as MonthlyClaimActivity[],
    closedYtd: defaultMetricBase, 
    lifetimeClosed: defaultMetricBase,
    openClaimsByCarrier: [] as ClaimsByCarrier[], 
    payrollByMonth: [] as AdjusterPayrollByMonth[],     
    ytdPayrollAmt: defaultMetricBase,
}
